import React from "react";
import "./imageWithTextBlock.css";

const ImageWithTextBlock = ({ shortTitle, title, description, image, imagePosition, imageSize = "small" }) => {

    return (
        <div className={"image-with--text-block image-position--" + imagePosition + " image-size--" + imageSize}>
            <div className="image-text-block--text">
                {shortTitle !== "" && (<button className="title-button title-button--secondary">{shortTitle}</button>)}
                {title !== "" && (<h4>{title}</h4>)}
                {description !== "" && (<p>{description}</p>)}
            </div>
            {image !== "" && (<div className="image-text-block--image">
                <img src={image} alt={title} />
            </div>)}
        </div>
    );
};

export default ImageWithTextBlock;
